exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DetailsList_details-wrapper_3IR_ {\n  margin: 16px 0 0 0;\n  padding: 0;\n\n  list-style: none;\n}\n\n  .DetailsList_details-wrapper__item_1iw5 {\n    margin-bottom: 8px;\n\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 14px;\n\n    color: #191c22\n  }\n\n  .DetailsList_details-wrapper__item_1iw5:last-of-type {\n  margin-bottom: 0;\n}\n", ""]);

// exports
exports.locals = {
	"details-wrapper": "DetailsList_details-wrapper_3IR_",
	"details-wrapper__item": "DetailsList_details-wrapper__item_1iw5"
};